// The one pill shape this screen uses. Extracted because the queue's label-state pill and
// the outcome badge sat side by side on the same row with different borders and paddings —
// two shapes for the same kind of information.
export const PILL_CLASS = 'inline-flex rounded-full border px-2 py-0.5 text-xs font-medium'

export const Pill = ({ tone = '', children }) => <span className={`${PILL_CLASS} ${tone}`}>{children}</span>
